import { render, staticRenderFns } from "./AssemblyParticipation.vue?vue&type=template&id=088f70d4&scoped=true"
import script from "./AssemblyParticipation.vue?vue&type=script&lang=js"
export * from "./AssemblyParticipation.vue?vue&type=script&lang=js"
import style0 from "./AssemblyParticipation.vue?vue&type=style&index=0&id=088f70d4&prod&lang=scss"
import style1 from "./AssemblyParticipation.vue?vue&type=style&index=1&id=088f70d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088f70d4",
  null
  
)

export default component.exports